import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Destinations from "../components/Destinations";
import CTABanner from "../components/CTABanner";

const PageHero = ({ title, subtitle, image }) => (
  <section className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden">
    <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-r from-slate-950/85 to-slate-900/50" />
    <div className="relative max-w-7xl mx-auto px-6 text-white">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur border border-white/20 text-white text-xs font-semibold tracking-wider uppercase">
        <span className="w-1.5 h-1.5 rounded-full bg-orange-400" /> {subtitle}
      </div>
      <h1 className="mt-4 text-4xl md:text-6xl font-bold tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
        {title}
      </h1>
    </div>
  </section>
);

const DestinationsPage = () => {
  return (
    <>
      <Header />
      <main>
        <PageHero
          title="Explore Every Corner of India"
          subtitle="Destinations"
          image="https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1920&q=80"
        />
        <Destinations />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
};

export default DestinationsPage;
